import React from 'react';

import BackgroundImage from '../../media/images/LoginBackground.jpg';

import Header from '../Header';

import { useTranslation, withTranslation } from 'react-i18next';

import './ExpiredListMessage.css';
import {useCabanaContext} from "../CabanaContext";
import {Link} from "react-router-dom";

function ExpiredListMessage() {
    const {t} = useTranslation();
    const {userType} = useCabanaContext();
    console.log(userType)
    interface ButtonReturnProps {
        userType: string;
    }

    const ButtonReturn: React.FC<ButtonReturnProps> = ({ userType }) => {
        if (userType !== 'giftee') return null;

        return (
            <div className="ButtonContainer" style={{ width: 'calc(100% - 40px)', marginBottom: '0!important' }}>
                <Link className="Fgift-button" style={{ width: '100%', height: '50px!important' }} to="/">
                    Return
                </Link>
            </div>
        );
    };
    return (
        <div className="ExpiredListMessageContainer">
            <Header hideLogout={true} showWishlistLink={false} showCart={false}/>
            <div>
                <div className={'container-images-and-text'}>
                    <div style={{backgroundImage: `url(${BackgroundImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}} className="ExpiredListImageContainer">
                    </div>
                    <div className={'ExpiredListInfosContainer'}>
                        <h1>{t('expiredListMessageTitle')}</h1>
                        <h3>{t('expiredListMessageSubtitle')}</h3>
                        <ButtonReturn userType={userType} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withTranslation()(ExpiredListMessage);